import { Box, Popover, Portal, Text } from '@lego/klik-ui';
import { StatusCircleExclamation } from '@lego/klik-ui/icons';
import { type MouseEvent, useState } from 'react';

export const isImmediateStrategy = (strategy: string | null | undefined): boolean =>
  strategy === 'IMMEDIATE' || strategy === 'IMMEDIATE_APPLICATION_ONLY';

// Opens on hover and stays open when clicked until clicked again or dismissed.
export const ImmediateStrategyWarning = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPinned, setIsPinned] = useState(false);

  return (
    <Popover
      isLazy
      isOpen={isHovered || isPinned}
      onClose={() => {
        setIsHovered(false);
        setIsPinned(false);
      }}
      placement="top"
    >
      <Popover.Trigger>
        <Box
          as="button"
          display="inline-flex"
          onClick={(e: MouseEvent) => {
            e.stopPropagation();
            setIsPinned((pinned) => !pinned);
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          type="button"
        >
          <StatusCircleExclamation color="warning.400" />
        </Box>
      </Popover.Trigger>
      <Portal>
        <Popover.Content p={3}>
          <Popover.Arrow />
          <Popover.Body p={0}>
            <Text fontWeight="bold" mb={1}>
              Immediate deployment is risky
            </Text>
            <Text>
              Changes roll out to devices right away, without a controlled window, so a faulty
              update can reach devices at a bad time. Rollout windows and schedules are much more
              predictable. Consider using Schedule instead.
            </Text>
          </Popover.Body>
        </Popover.Content>
      </Portal>
    </Popover>
  );
};
